// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"244":"a8fcccb4","409":"31c42fcb","645":"d27862d6","915":"db2a8211"}[chunkId] + ".css";
};